import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {forkJoin} from 'rxjs';
import {finalize, switchMap, tap} from 'rxjs/operators';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubmissionService {
  currentSubmission: any = {};
  submissions: any;
  user: any = {};
  loading = false;
  loadingContent = false;
  submitting = false;
  searchParam: any;
  saving = false;
  meta: any = {};
  constructor(public http: HttpClient) {
  }

  getSubmission(id) {
    this.loading = true;
    this.meta = {submissionAddType: `beaches/submission/${id}/add/`}
    return this.http.get(`${environment.baseUrl}/beaches/submission/${id}/`).pipe(
      tap((submission: any) => this.currentSubmission = {...this.currentSubmission, ...submission.result}),
      finalize(() => this.loading = false)
    );
  }


  // loadSubmission: function (id) {
  //     Restangular.one('beaches/submission', id).get().then(function (submission) {
  //         this.currentSubmission = submission;
  //     });
  // },
  // loadSubmissions(searchParams) {
  //   return this.monitoringSubmissionService.getList(searchParams).pipe(
  //     switchMap(r => forkJoin({
  //       notifications: this.notificationSubmissionService.getList(searchParams)
  //     })),
  //     tap(responses => {
  //          if (responses.items.results) {
  //         merge(responses.items, responses.notifications.results);
  //       }else{
  //         this.item = {};
  //       }
  //          merge(this.meta, responses.items.meta);
  //          return ({response: {meta: this.meta, results: responses.items}});
  //
  //     }));
  // }

  loadSubmission(id) {
    this.loading = true;
    this.loadingContent = true;

    const submissionObs = this.getSubmission(id);
    const monitoring_loaction_url = `${environment.baseUrl}/beaches/monitoringlocation/`;
    var locationPromise = this.http.get(monitoring_loaction_url, {
      params: {
        search: id,
        page_size: '1000',
        ordering: 'id'
      }
    }).pipe(
      tap((locations: any) => {
        this.currentSubmission.locations = locations.results;
        this.currentSubmission.locations.meta = locations.meta;
        this.currentSubmission.locations.meta.url = monitoring_loaction_url
        this.currentSubmission.locations.meta.display_fields = ['name', 'locationid', 'type', 'collection_method', 'datum',
          'horizontal_collection_method'];
        this.currentSubmission.locations.meta.type = 'beaches/monitoringlocation';
        this.currentSubmission.locations.meta.verbose_name = 'Monitoring Location';
        this.currentSubmission.locations.meta.verbose_name_plural = 'Monitoring Locations';
        this.currentSubmission.locations.meta.autocomplete = {
          "url": "/api/beaches/monitoringlocation/?search=",
          "foreign_key": "site",
          "field": "name"
        };
      })
    );

    const activity_url = `${environment.baseUrl}/beaches/monitoringactivity/`;
    const activity_params = {
        search: id,
        ordering: 'activityid,-sample_collection_datetime'
      }
    var activityPromise = this.http.get(activity_url, {
      params: activity_params
    }).pipe(
      tap((activities: any) => {
        this.currentSubmission.activities = activities.results;
        this.currentSubmission.activities.meta = activities.meta;
        this.currentSubmission.activities.meta.url = activity_url
        // adding search params enableds infinite scroll on submission list directive.
        this.currentSubmission.activities.meta.searchParams = activity_params
        this.currentSubmission.activities.meta.display_fields = [
          'activityid', 'type', 'media', 'sample_collection_datetime', 'sample_collection_equipment', 'sample_collection_methodid',
          'sample_collection_method_context', 'sample_collection_name'
        ];
        this.currentSubmission.activities.meta.type = 'beaches/monitoringactivity';
        this.currentSubmission.activities.meta.subItems = ['result'];
        // Beaches.meta.fields.monitoring_activity.verbose_name = 'Monitoring Activity';
        // Beaches.meta.fields.monitoring_activity.verbose_name_plural = 'Monitoring Activities';
        this.currentSubmission.activities.meta.autocomplete = {
          "url": "/api/beaches/monitoringactivity/?search=",
          "foreign_key": "monitoring_location",
          "field": "activityid"
        };

        //results
        this.currentSubmission.activities.meta.fields.result = {
          fields: activities.meta.fields.result.child.fields,
          verbose_name_plural: 'Results',
          verbose_name: 'Result',
          display_fields: ['characteristicname', 'status', 'valuetype', 'measure', 'units', 'geometric_mean'],
          foreign_key_field: 'monitoring_activity',
          deleteText: 'Are you sure you want to remove this result from this activity?'
        };
      })
    );

    var beachMeta;
    const beach_url = `${environment.baseUrl}/beaches/beach/`;
    var beachPromise = this.http.get(beach_url, {params: {search: id, page_size: "1000"}})
      .pipe(tap((beaches: any) => {
          this.currentSubmission.beaches = beaches.results;
          beachMeta = beaches.meta;
          beachMeta.url = beach_url;
          beachMeta.display_fields = ['name', 'identifier', 'description', 'comment', 'state_code', 'fips_code',
            'access_type', 'access_comment', 'waterbody_name_code', 'waterbody_type_code', 'extent_length_measure',
            'extent_unit_of_measure', 'effective_year', 'swim_season_startdate', 'swim_season_enddate', 'swim_season_frequency_measure',
            'monitoring_freq_unit_of_measure', 'monitored_irregularly', 'monitored_irregularly_comment', 'tier_ranking',
            'beach_act_indicator', 'pollution_status', 'dormant_indicator', 'website', 'reporting_frequency_measure',
            'reporting_freq_unit_of_measure'];

          beachMeta.type = 'beaches/beach';
          beachMeta.autocomplete = {
            "url": "/api/beaches/beach/?search=",
            "foreign_key": "monitoring_location",
            "field": "name"
          };
          beachMeta.subItems = ['beach_advisory', 'pollution', 'procedure'];
          const beach_aggregate_url = `${environment.baseUrl}/beaches/beachadvisoryaggregate/`;
          this.http.get(beach_aggregate_url, {
            params: {
              search: id,
              page_size: "9999"
            }
          }).pipe(tap((advisories: any) => {
              this.currentSubmission.beaches.forEach((beach: any, i) => {
                beach.beach_advisory = advisories.results.filter(a => a.beach === beach.globalid);
              });
              // this.currentSubmission.beaches.beach_advisory = advisories;
              beachMeta.fields.beach_advisory = advisories.meta;
              beachMeta.fields.beach_advisory.url = beach_aggregate_url;
              beachMeta.fields.beach_advisory.display_fields = ['type_code',
                'actual_startdate', 'actual_stopdate', 'activity_description',
                'activity_comment',
                'activity_reason', 'activity_source', 'activity_indicator'];
              beachMeta.fields.beach_advisory.foreign_key_field = 'beach';
            })
          ).subscribe();
          const beach_procedure_url = `${environment.baseUrl}/beaches/procedure/`;
          this.http.get(beach_procedure_url, {
            params: {
              search: id,
              page_size: "9999"
            }
          }).pipe(tap((procedures: any) => {
              this.currentSubmission.beaches.forEach((beach, i) => {
                beach.procedure = procedures.results.filter(p => p.beach === beach.globalid);
              });
              beachMeta.fields.procedure = procedures.meta;
              beachMeta.fields.procedure.url = beach_procedure_url;
              beachMeta.fields.procedure.display_fields = ['type_code', 'description'];
              beachMeta.fields.procedure.foreign_key_field = 'beach';
            })
          ).subscribe();

          const beach_pollution_url = `${environment.baseUrl}/beaches/pollution/`;
          this.http.get(beach_pollution_url, {
            params: {
              search: id,
              page_size: "9999"
            }
          }).pipe(tap((pollution: any) => {
              this.currentSubmission.beaches.forEach((beach, i) => {
                beach.pollution = pollution.results.filter(b => b.beach === beach.globalid);
              });
              beachMeta.fields.pollution = pollution.meta;
              beachMeta.fields.pollution.url = beach_pollution_url;
              beachMeta.fields.pollution.display_fields = ['source_code', 'source_description'];
              beachMeta.fields.pollution.foreign_key_field = 'beach';
            })
          ).subscribe();
        })
      );

    submissionObs.pipe(
      switchMap(() => forkJoin([locationPromise, activityPromise, beachPromise])),
      finalize(() => {
        this.currentSubmission.beaches.meta = beachMeta;
        this.loadingContent = false
      })
    ).subscribe()
  }

  createSubmission(compType) {
    this.saving = true;
    this.currentSubmission.compilation_type = compType;
    return this.http.post(`${environment.baseUrl}/beaches/submission/`, this.currentSubmission).pipe(
      tap((response: any) => {
        this.currentSubmission = response;
        this.loadSubmission(response.globalid);
      }),
      finalize(() => {
        this.saving = false;
      })
    ).subscribe()
  }

  submitSubmission() {
    if (this.user.email !== undefined && this.user.password !== undefined) {
      this.submitting = true;
      this.http.post(`${environment.baseUrl}/user/submit_cdx_creds/`, {
        'username': this.user.email,
        'password': this.user.password
      }).pipe(
        switchMap(() => this.http.post(`${environment.baseUrl}/beaches/submission/${this.currentSubmission.globalid}/submit/`, {})),
        tap((response: any) => {
          this.currentSubmission.status = response.status;
          this.currentSubmission.statusDescription = response.statusDescription;
          this.currentSubmission.date = response.date;
        }),
        finalize(() => {
          this.submitting = false;
        })
      ).subscribe();

    } else {
      // toastr.error('Please provide CDX credentials.')
    }
  }

  updateSubmission() {
    this.submitting = true;
    this.http.post(`${environment.baseUrl}/user/submit_cdx_creds/`, {
      'username': this.user.email,
      'password': this.user.password
    }).pipe(
      switchMap(() => this.http.post(`${environment.baseUrl}/beaches/submission/${this.currentSubmission.globalid}/update_status/`, {})),
      tap((response: any) => {
        this.currentSubmission.status = response.status;
        this.currentSubmission.statusDescription = response.statusDescription;
        this.currentSubmission.date = response.date;
      }),
      finalize(() => {
        this.submitting = false;
      })).subscribe();
  }

  getSubmissionReport() {
    this.http.post(`${environment.baseUrl}/user/submit_cdx_creds/`, {
      'username': this.user.email,
      'password': this.user.password
    }).pipe(
      tap(() => window.open(`${environment.baseUrl}/beaches/submission/${this.currentSubmission.globalid}/get_report/`, '_blank'))
    ).subscribe();
  }

  getUser() {
    this.http.get(`${environment.baseUrl}/user`).pipe(
      tap((user) => {
        this.user = {...this.user, ...user};
      })
    );
  }

  removeFromSubmission(item) {
    this.http.post(`${environment.baseUrl}/beaches/submission/${this.currentSubmission.globalid}/remove/`, item).pipe(
      tap(() => this.loadSubmission(this.currentSubmission.globalid))
    ).subscribe();
  }
}
